<template>
    <div v-if="tripadvisorRating.rating || tripadvisorRating.reviewsURL">
        <component
            :is="tripadvisorRating.reviewsURL ? 'a' : 'span'"
            :href="tripadvisorRating.reviewsURL"
            target="_blank"
            class="d-flex align-center text-decoration-none"
        >
            <img
                v-if="!tripadvisorRating.rating"
                :src="$filters.srcHost('/tripadvisor/ta.svg')"
                alt="Tripadvisor"
                height="20"
            />
            <img
                v-else
                :src="$filters.srcHost(`/tripadvisor/ta-${tripadvisorRating.rating * 10}.svg`)"
                :alt="tripadvisorRating.rating"
            />
            <span
                v-if="tripadvisorRating.reviewsCount"
                class="text-caption text-secondary ms-1 text-truncate"
                :class="{'text-decoration-underline': tripadvisorRating.reviewsURL}"
            >
                {{ $t('based_on') }} {{ $t('review', tripadvisorRating.reviewsCount) }}
            </span>
        </component>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class TripadvisorRating extends Vue {
        @Prop() tripadvisorRating
    }

    export default TripadvisorRating
</script>
